import React, { useContext, useEffect } from 'react';
import { PageSectionPB } from '../shared';
import {
  NationalAccountContext,
  NationalAccountProvider,
} from '../../../contexts';
import { shared } from '../../../constants/NationalAccount';
import {
  EnrollModals,
  UnenrollModals,
} from './components/NationalAccountModals';
import {
  NotEnrolledSummary,
  AlreadyEnrolledSummary,
} from './components/PageSummaries';
import { usePricingContext } from '../../../contexts/pricing-context';

export const NationalAccount = ({ nationalAccount, isMobile }: any) => {
  const { shouldShowPricingBookPage } = usePricingContext();
  return (
    <PageSectionPB
      title={shared.title}
      classes={
        shared.type === 'NAI' && shouldShowPricingBookPage
          ? ''
          : 'sui-pt-4 sui-mt-2'
      }
      isMobile={isMobile}
      type={shared.type}
    >
      <NationalAccountProvider>
        <NationalAccountPageAndModal
          nationalAccount={nationalAccount}
          isMobile={{ isMobile }}
        />
      </NationalAccountProvider>
    </PageSectionPB>
  );
};
const NationalAccountPageAndModal = ({
  nationalAccount,
  isMobile,
}: any): JSX.Element => {
  const { setIsMobile, setCurrentAgreementCode } = useContext(
    NationalAccountContext,
  );

  useEffect(() => {
    setIsMobile(isMobile);
    setCurrentAgreementCode(nationalAccount?.agreementCodes[0]);
  }, [nationalAccount?.agreementCodes]);

  return nationalAccount?.agreementCodes &&
    nationalAccount?.agreementCodes?.length > 0 ? (
    <>
      <AlreadyEnrolledSummary />
      <UnenrollModals />
    </>
  ) : (
    <>
      <NotEnrolledSummary />
      <EnrollModals />
    </>
  );
};
